package com.xtream.data_kmp

import androidx.room3.Embedded
import androidx.room3.Entity
import androidx.room3.Ignore
import androidx.room3.Index
import androidx.room3.PrimaryKey
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.StreamType
import com.xtream.data_kmp.dto.VodStream
import kotlin.time.Clock


abstract class WatchedBaseStream(
    @PrimaryKey var streamId: Int,
    var progress: Long?,
    var totalProgress: Long?,
    var backdrop: String?
) {
    var added:Long = Clock.System.now().toEpochMilliseconds()

    @Ignore
    val type: StreamType = StreamType.BACKDROP

}
const val watchedLiveStreamsTable="watchedLiveStreamsTable"
@Entity(watchedLiveStreamsTable)
 data class WatchedLiveStreams(
    @PrimaryKey
    var streamId: Int,
    var added:Long = Clock.System.now().toEpochMilliseconds(),
   )
const val watchedVodStreamsTable="watchedVodStreamsTable"
@Entity(watchedVodStreamsTable)
class WatchedVodStreams(streamId: Int,   progress: Long?,
                        totalProgress: Long?,
                        backdrop: String?): WatchedBaseStream(streamId, progress = progress, totalProgress = totalProgress,backdrop)



const val watchedSeriesStreamsTable="watchedSeriesStreamsTable"
@Entity(watchedSeriesStreamsTable, indices = [Index(value = ["streamId","episodeId"], unique = true)] )
class WatchedSeriesStreams( streamId: Int,
                           val episodeId:Int,
                             progress: Long?,
                            val videoExtension:String?,
                            totalProgress: Long?,
                            backdrop: String?): WatchedBaseStream(streamId, progress = progress, totalProgress = totalProgress,backdrop)

 data class WatchedIntermediateVodStream(
     @Embedded val baseStream: VodStream,
     @Embedded(prefix = "watched_") val watchedBaseStream: WatchedVodStreams

)

 data class WatchedIntermediateSeriesStream(
     @Embedded val baseStream: SeriesStream,
     @Embedded(prefix = "watched_") val watchedBaseStream: WatchedSeriesStreams

)
/*

//migrations
@DeleteColumn.Entries(
    DeleteColumn(
        tableName = "watchedLiveStreamsTable",
        columnName = "addedAAt"
    )
)
class AutoMigrateWatchedLiveStreams : AutoMigrationSpec {

    override suspend fun onPostMigrate(connection: SQLiteConnection) {
        super.onPostMigrate(connection)
    }
    
}

*/
